import AuthLayout from "../../Components/Layouts/AuthLayout";
import {Card, CardBody, Col, Container, Row} from "react-bootstrap";
import {Link} from "react-router-dom";

const Settings = () => {
    return (
        <>
            <AuthLayout>
                <div className="mb-4">
                    <h3>Settings</h3>
                </div>


               <Container fluid className="rounded shadow settings">

                               <Row className="px-5 py-5">

                                   <Col md={4} sm={12} className="mt-3">
                                       <Link to={'/job-settings/job-type'} className="text-decoration-none">
                                       <Card className="shadow border-0">
                                           <CardBody className="p-4">
                                               <img src="/svg/Group1.svg" alt="Jobs" className="img-fluid" width={80} />
                                               <div className="py-3">
                                                   <h4>Jobs</h4>
                                               </div>
                                               <div>
                                                   <p>Lorem ipsum dolor sit amet.
                                                       Sit voluptas internos id modi quae qui
                                                       voluptas rerum aut quasi quia quo beatae quam
                                                       sed enim pariatur. Aut reiciendis quaerat nam ullam
                                                       expedita est repellat fuga rem corrupti labore qui
                                                       aspernatur velit et odit aspernatur sed quae possimus? S
                                                       ed quas error aut molestiae galisum At repellendus similique?</p>
                                               </div>

                                           </CardBody>
                                       </Card>
                                       </Link>
                                   </Col>



                                       <Col md={4} sm={12} className="mt-3">
                                           <Link to={''} className="text-decoration-none">
                                           <Card className="shadow border-0">
                                               <CardBody className="p-4">
                                                   <img src="/svg/Group2.svg" alt="Interview" className="img-fluid" width={80} />
                                                   <div className="py-3">
                                                       <h4>Interview</h4>
                                                   </div>
                                                   <div>
                                                       <p>Lorem ipsum dolor sit amet.
                                                           Sit voluptas internos id modi quae qui
                                                           voluptas rerum aut quasi quia quo beatae quam
                                                           sed enim pariatur. Aut reiciendis quaerat nam ullam
                                                           expedita est repellat fuga rem corrupti labore qui
                                                           aspernatur velit et odit aspernatur sed quae possimus? S
                                                           ed quas error aut molestiae galisum At repellendus similique?</p>
                                                   </div>

                                               </CardBody>
                                           </Card>
                                           </Link>
                                       </Col>



                                       <Col md={4} sm={12} className="mt-3">
                                           <Link to={''} className="text-decoration-none">
                                           <Card className="shadow border-0">
                                               <CardBody className="p-4">
                                                   <img src="/svg/Group3.svg" alt="onboarding" className="img-fluid" width={80} />
                                                   <div className="py-3">
                                                       <h4>Onboarding</h4>
                                                   </div>
                                                   <div>
                                                       <p>Lorem ipsum dolor sit amet.
                                                           Sit voluptas internos id modi quae qui
                                                           voluptas rerum aut quasi quia quo beatae quam
                                                           sed enim pariatur. Aut reiciendis quaerat nam ullam
                                                           expedita est repellat fuga rem corrupti labore qui
                                                           aspernatur velit et odit aspernatur sed quae possimus? S
                                                           ed quas error aut molestiae galisum At repellendus similique?</p>
                                                   </div>

                                               </CardBody>
                                           </Card>
                                           </Link>
                                       </Col>


                                   <Col md={4} sm={12} className="mt-3">
                                       <Link to={''} className="text-decoration-none">
                                           <Card className="shadow border-0">
                                               <CardBody className="p-4">
                                                   <img src="/svg/Group4.svg" alt="template" className="img-fluid" width={80} />
                                                   <div className="py-3">
                                                       <h4>Template</h4>
                                                   </div>
                                                   <div>
                                                       <p>Lorem ipsum dolor sit amet.
                                                           Sit voluptas internos id modi quae qui
                                                           voluptas rerum aut quasi quia quo beatae quam
                                                           sed enim pariatur. Aut reiciendis quaerat nam ullam
                                                           expedita est repellat fuga rem corrupti labore qui
                                                           aspernatur velit et odit aspernatur sed quae possimus? S
                                                           ed quas error aut molestiae galisum At repellendus similique?</p>
                                                   </div>

                                               </CardBody>
                                           </Card>
                                       </Link>
                                   </Col>

                                   <Col md={4} sm={12} className="mt-3">
                                       <Link to={''} className="text-decoration-none">
                                           <Card className="shadow border-0">
                                               <CardBody className="p-4">
                                                   <img src="/svg/Group5.svg" alt="Jobs" className="img-fluid" width={80} />
                                                   <div className="py-3">
                                                       <h4>Theme Customization</h4>
                                                   </div>
                                                   <div>
                                                       <p>Lorem ipsum dolor sit amet.
                                                           Sit voluptas internos id modi quae qui
                                                           voluptas rerum aut quasi quia quo beatae quam
                                                           sed enim pariatur. Aut reiciendis quaerat nam ullam
                                                           expedita est repellat fuga rem corrupti labore qui
                                                           aspernatur velit et odit aspernatur sed quae possimus? S
                                                           ed quas error aut molestiae galisum At repellendus similique?</p>
                                                   </div>

                                               </CardBody>
                                           </Card>
                                       </Link>
                                   </Col>

                               </Row>

               </Container>
            </AuthLayout>

        </>
    );
};

export default Settings;